import React from 'react'


const Footer = () => {
  return (
      <>
      <div>
        <div className="footer">
           <p>Customer Service Contact: 1800-000-0000</p>
        </div>
      </div>
      </>
  )
}

export default Footer